import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-spinner',
  standalone: true,
  template: `<span class="custom-spinner" role="status" aria-label="Loading"></span>`,
  styles: [
    `
      :host {
        position: absolute;
        inset: 0;
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 9999;
      }

      .custom-spinner {
        width: 42px;
        height: 42px;
        border: 4px solid rgb(0 127 4 / 20%);
        border-top-color: #007f04;
        border-radius: 50%;
        animation: spinner-rotate 700ms linear infinite;
      }

      @keyframes spinner-rotate {
        to {
          transform: rotate(360deg);
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {}
